"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageClient = void 0;
const BaseClient_1 = require("../BaseClient");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class StorageClient extends BaseClient_1.BaseClient {
    constructor(entity, baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
        this.entity = entity;
    }
    get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: `/api/v1/storage/get`,
                params: {
                    entity: this.entity,
                    id,
                },
            });
            return response.data;
        });
    }
    list(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/storage/list',
                data: Object.assign(Object.assign({}, request), { entity: this.entity }),
            });
            return response.data;
        });
    }
    listColumns(request, ...columns) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/storage/listColumns',
                data: Object.assign(Object.assign({}, request), { entity: this.entity, columns: columns }),
            });
            return response.data;
        });
    }
    listParents(id, includeSelf) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/api/v1/storage/listParents',
                params: {
                    entity: this.entity,
                    id,
                    includeSelf,
                },
            });
            return response.data;
        });
    }
    /**
     * Convenience method to get count of rows by filter
     */
    count(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.list({ filter: request.filter, limit: 0 });
            return response.total;
        });
    }
    post(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/storage/post',
                data: Object.assign(Object.assign({}, request), { entity: this.entity }),
            });
            return response.data;
        });
    }
    massCreate(request) {
        return __awaiter(this, void 0, void 0, function* () {
            let req = request;
            if (Array.isArray(request)) {
                req = {
                    items: req.map((data) => ({ data: data })),
                };
            }
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/storage/massCreate',
                data: Object.assign(Object.assign({}, req), { entity: this.entity }),
            });
            return response.data;
        });
    }
    massUpdate(request) {
        return __awaiter(this, void 0, void 0, function* () {
            let nullFields = undefined;
            if (request.data) {
                nullFields = [];
                Object.entries(request.data).forEach(([key, value]) => {
                    if (value == null) {
                        nullFields.push(key);
                    }
                });
            }
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/storage/massUpdate',
                data: Object.assign(Object.assign({}, request), { entity: this.entity, nullFields }),
            });
            return response.data;
        });
    }
    massDelete(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/storage/massDelete',
                data: Object.assign(Object.assign({}, request), { entity: this.entity }),
            });
            return response.data;
        });
    }
}
exports.StorageClient = StorageClient;
